import { formatDateWithLocalTZ } from "@ticomix/common";
import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

import { IMobileLoginRequest } from "./i-imobile-login-request";
import { throwException, blobToText } from "./api-utilities";

export class MobileLoginRequest implements IMobileLoginRequest {
  PhoneNumber!: string;
  Password!: string;
  TwoFactorCode?: string | null;

  constructor(data?: IMobileLoginRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.PhoneNumber = "";
      this.Password = "";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.PhoneNumber =
        _data["PhoneNumber"] !== undefined ? _data["PhoneNumber"] : "";
      this.Password = _data["Password"] !== undefined ? _data["Password"] : "";
      this.TwoFactorCode =
        _data["TwoFactorCode"] !== undefined
          ? _data["TwoFactorCode"]
          : <any>null;
    }
  }

  static fromJS(data: any): MobileLoginRequest {
    data = typeof data === "object" ? data : {};
    let result = new MobileLoginRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["PhoneNumber"] =
      this.PhoneNumber !== undefined ? this.PhoneNumber : <any>null;
    data["Password"] = this.Password !== undefined ? this.Password : <any>null;
    data["TwoFactorCode"] =
      this.TwoFactorCode !== undefined ? this.TwoFactorCode : <any>null;
    return data;
  }
}
